// Homepage (the title card): the approach table that frames the conversation, then the one big
// "Build a business case" card. The logo returns here from anywhere; the card always opens the account step (the case is kept).

import { iconUrl } from '../../data/icons';
import { Ph } from '../Icon';
import { ApproachTable } from './ApproachTable';

interface TitleCardProps {
  onBuildBusinessCase: () => void;
}

export function TitleCard({ onBuildBusinessCase }: TitleCardProps) {
  return (
    <section className="vc3-title" aria-labelledby="vc3-title-h">
      <h1 id="vc3-title-h" className="vc3-h1">
        How Clay&rsquo;s technical wins drive business value
      </h1>
      <ApproachTable />
      <hr className="vc3-ucp-divider vc3-title-divider" />
      <div className="vc3-options">
        <button type="button" className="vc3-card vc3-card-primary" onClick={onBuildBusinessCase}>
          <img className="vc3-card-icon" src={iconUrl('assets/icons/Build-campaign.png')} alt="" />
          <div className="vc3-card-body">
            <h2>Build a business case</h2>
            <p>
              Choose the use cases you will adopt, enter your own numbers, and size the value Clay can
              take credit for.
            </p>
            <span className="vc3-card-go">
              Start <Ph name="arrow-right" size={28} />
            </span>
          </div>
        </button>
      </div>
    </section>
  );
}
